import { __rest } from 'tslib';
import { jsxs, jsx } from 'react/jsx-runtime';
import React from 'react';
import classnames from 'classnames';
import { Body, Tooltip } from '@cognite/cogs-core';
import { InfoFilledIcon } from '@cognite/cogs-icons';
import { IconWrapper } from '@cognite/cogs-utils';

/**
 * Component to group ActionList Items into sections.
 */
var ActionListSection = /*#__PURE__*/React.forwardRef(function (_a, ref) {
  var className = _a.className,
    label = _a.label,
    infoTooltipOptions = _a.infoTooltipOptions,
    children = _a.children,
    otherProps = __rest(_a, ["className", "label", "infoTooltipOptions", "children"]);
  return jsxs("div", Object.assign({
    ref: ref,
    className: classnames('cogs-actionlist__section', className)
  }, otherProps, {
    children: [jsxs("div", {
      className: "cogs-actionlist__section-body",
      children: [label && jsxs(Body, {
        as: "span",
        size: "x-small",
        muted: true,
        className: classnames('cogs', 'cogs-actionlist__section__label'),
        children: [label, infoTooltipOptions && jsx(Tooltip, Object.assign({}, infoTooltipOptions, {
          children: jsx(IconWrapper, {
            "aria-label": 'Information tooltip',
            tabIndex: 0,
            className: classnames('cogs', 'cogs-actionlist__section__label__info-icon'),
            size: 12,
            children: jsx(InfoFilledIcon, {})
          })
        }))]
      }), children]
    }), jsx("div", {
      className: "divider"
    })]
  }));
});

export { ActionListSection };
